import { render, staticRenderFns } from "./RepresentantesForm.vue?vue&type=template&id=05771a9e&scoped=true&"
import script from "./RepresentantesForm.vue?vue&type=script&lang=js&"
export * from "./RepresentantesForm.vue?vue&type=script&lang=js&"
import style0 from "./RepresentantesForm.vue?vue&type=style&index=0&id=05771a9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05771a9e",
  null
  
)

export default component.exports